import axios from "../utils/apicall";

// Suppress 429 spam from log batching during rate limiting
axios.interceptors.response.use(
  (res) => res,
  (err) => {
    const url = err?.config?.url || "";
    if (url.includes("/logviewer/frontendlogs") && err.response?.status === 429) {
      return Promise.resolve();
    }
    return Promise.reject(err);
  }
);
